import { createSceneReducer } from 'reducers/reducers-util';
import chatsDataReducer from 'components/admin/chats/store/reducers.data';

export default createSceneReducer(chatsDataReducer);
